//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 18/10/2024
// Version       : 1
// Description   : Para adjuntar archivos a las revisiones de los vehículos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Snackbar,
  SnackbarContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { UrlApi } from "../../services/apirest";
import { useEffect } from "react";
import { DownloadFiles } from "../../services/DownloadFiles";

// ICONOS
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import VisibilityIcon from "@mui/icons-material/Visibility";

// LOG EVENTOS
import { logEventos } from "../../services/services";

function FileUploadTareas(props) {
  const [openclose, setOpenClose] = useState(props.openclose);
  const [mostrar, setMostrar] = useState(props.mostrar);
  const [fileList, setFileList] = useState([]);
  const [snack, setSnack] = useState(false);
  const [mensaje, setMensaje] = useState("Guardando Archivos...");
  const [colortexto, setColorTexto] = useState("white");
  const [colorfondo, setColorFondo] = useState("black");
  const [archivos, setArchivos] = useState();
  // para ver imagenes
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    fetch(UrlApi + "/uploadfiles/todownload/" + props.fileId)
      .then((data) => data.json())
      .then((data) => setArchivos(data));
  }, [snack]);

  const borraAdjunto = (e, id, archive) => {
    logEventos(
      "Borrar adjunto revisión",
      "Revision Vehiculos",
      "Borrar archivo adjunto de revisión de vehículos",
      localStorage.getItem("user")
    );

    e.preventDefault();
    if (window.confirm("Seguro de borrar el archivo " + archive)) {
      fetch(UrlApi + "/uploadfiles/todownload/" + id, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }).then((res) =>
        res.ok
          ? (setMensaje("Archivo borrado"),
            setColorTexto("white"),
            setColorFondo("green"),
            setSnack(true))
          : (setMensaje("No se borró el archivo"),
            setColorTexto("white"),
            setColorFondo("red"),
            setSnack(true))
      );
    }
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack(false);
  };

  const handleFileChange = (e) => {
    setFileList(e.target.files);
  };

  const removefiles = (e) => {
    const s = Array.from(fileList).filter((item, index) => index !== e);
    setFileList(s);
    console.log(fileList);
  };

  const handleClose = () => {
    setOpenClose(false);
    setMensaje("Guardar Archivos Cancelado");
    setColorTexto("white");
    setColorFondo("red");
    if (props.onClose) {
      props.onClose();
    }
  };

  const handleUploadClick = () => {
    logEventos(
      "Guardar adjuntos revisión",
      "Revision",
      "Guardar archivos adjuntos de revisión de vehículos",
      localStorage.getItem("user")
    );

    if (!fileList) {
      setMensaje("No hay archivos para guardar");
      setSnack(true);
      setColorTexto("white");
      setColorFondo("red");
      setOpenClose(false);
      return;
    }
    // Creación de objeto "FormData" y se le agregan los archivos
    const data = new FormData();
    data.append("uid", props.fileId); // Se agrega UUID que se recibe como parametro
    for (let i = 0; i < fileList.length; i++) {
      data.append("archivo", fileList[i]);
    }
    console.log("esto mando a guardar", fileList);
    // Uploading de los archivos con Fetch a la API
    fetch(UrlApi + "/uploadfiles/uploadfiles", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then(
        (data) => setMensaje(data.message),
        setSnack(true),
        setColorTexto("white"),
        setColorFondo("green"),
        setFileList([])
      )
      .catch((err) => console.error(err));
  };

  const fetchPdf = async (archivo) => {
    const response = await fetch(UrlApi + "/uploadfiles/uploadspdf/" + archivo);
    setImageUrl(URL.createObjectURL(await response.blob()));
  };

  const fetchImage = async (archivo) => {
    const response = await fetch(UrlApi + "/uploadfiles/uploads/" + archivo);
    setImageUrl(URL.createObjectURL(await response.blob()));
  };

  const ViewFiles = async (archivo, extension) => {
    (await extension) === "application/pdf"
      ? fetchPdf(archivo)
      : fetchImage(archivo);
  };

  return (
    <div>
      <>
        {openclose ? (
          <div>
            <Dialog
              open={openclose}
              close={handleClose}
              fullWidth
              PaperProps={{
                sx: {
                  height: 600,
                },
              }}
            >
              {mostrar ? (
                <DialogTitle
                  sx={{
                    backgroundColor: "#0979B0",
                    border: "1px solid white",
                    color: "white",
                  }}
                >
                  <IconButton
                    component="label"
                    size="small"
                    sx={{
                      border: "1px solid white",
                      borderRadius: 1,
                      color: "white",
                      fontStyle: "italic",
                      paddingRight: "10px",
                    }}
                  >
                    <input
                      hidden
                      type="file"
                      multiple
                      onChange={handleFileChange}
                    />
                    <ContentPasteSearchIcon size="small" />
                    Agregar archivos
                  </IconButton>
                </DialogTitle>
              ) : (
                <DialogTitle
                  sx={{
                    border: "1px solid white",
                    borderRadius: 1,
                    color: "white",
                    fontStyle: "italic",
                    paddingRight: "10px",
                    backgroundColor: "#0979B0",
                  }}
                >
                  <ContentPasteSearchIcon size="small" />{" "}
                  <b>{"Archivos Adjuntos"}</b>
                </DialogTitle>
              )}
              <DialogContent>
                {console.log(fileList)}
                {fileList ? (
                  <Table size="small">
                    <TableBody>
                      {Array.from(fileList).map((file, i) => (
                        <TableRow key={i} sx={{ border: 1 }}>
                          <TableCell align="left" padding="none">
                            {mostrar ? (
                              <IconButton size="small">
                                <DeleteIcon
                                  onClick={() => removefiles(i)}
                                  color="error"
                                />
                              </IconButton>
                            ) : null}
                          </TableCell>
                          <TableCell align="left" padding="none">
                            {file.name} - {(file.size / 1000).toFixed(2)} kb
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : null}

                <Divider />
                <Table size="small">
                  <TableBody>
                    {archivos ? (
                      archivos.map((archivo) => (
                        <TableRow key={archivo.id}>
                          <TableCell>
                            <IconButton
                              size="small"
                              color="secondary"
                              component="label"
                              disabled={
                                archivo.extension === "application/pdf" ||
                                archivo.extension === "image/jpeg"
                                  ? false
                                  : true
                              }
                            >
                              <VisibilityIcon
                                onClick={() =>
                                  ViewFiles(
                                    archivo.id_archivo + "-" + archivo.nombre,
                                    archivo.extension
                                  )
                                }
                              />
                            </IconButton>
                            <IconButton
                              size="small"
                              color="success"
                              component="label"
                            >
                              <DownloadForOfflineIcon
                                onClick={() =>
                                  DownloadFiles(
                                    archivo.id_archivo + "-" + archivo.nombre
                                  )
                                }
                              />
                            </IconButton>
                            {mostrar ? (
                              <IconButton
                                size="small"
                                color="error"
                                component="label"
                              >
                                <DeleteIcon
                                  onClick={(e) =>
                                    borraAdjunto(e, archivo.id, archivo.nombre)
                                  }
                                />
                              </IconButton>
                            ) : null}
                          </TableCell>
                          <TableCell>{archivo.nombre}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <Typography variant="h7">
                        No hay archivos adjuntos
                      </Typography>
                    )}
                  </TableBody>
                </Table>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} variant="outlined" color="error">
                  Volver
                </Button>
                {mostrar ? (
                  <Button
                    onClick={handleUploadClick}
                    variant="outlined"
                    color="success"
                  >
                    Guardar
                  </Button>
                ) : null}
              </DialogActions>
            </Dialog>
            {imageUrl && window.open(imageUrl, "_blank", "noreferrer")}
          </div>
        ) : null}

        <Snackbar
          open={snack}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <SnackbarContent
            style={{
              backgroundColor: colorfondo,
              color: colortexto,
              fontWeight: "bold",
            }}
            message={mensaje}
          />
        </Snackbar>
      </>
    </div>
  );
}

export default FileUploadTareas;
